export class PersonalityQuizResult {
    constructor(id: number, value: string) {
        this.id = id;
        this.value = value;
    }
    id: number;
    value: string;
}
